// qiankun 微前端配置
// 禁用 umi 插件的自动路由模式，改用手动 loadMicroApp
export const qiankun = () => {
  console.log('[app.ts] qiankun初始化 - 使用手动加载模式');

  return {
    apps: [],
    sandbox: true,
    prefetch: false,
  };
};
